import React, { useState, useEffect } from 'react';
import { Form, Button } from 'react-bootstrap';
import api from './api';

function DiyetisyenFormu({ mevcutDiyetisyen, onFormSubmit, onIptal }) {
  // 1. State tanımının 'klinik_id' içerdiğinden emin olalım
  const [formData, setFormData] = useState({
    kullanici_adi: '',
    eposta: '',
    telefon: '',
    sifre: '',
    abonelik_bitis_tarihi: '',
    klinik_id: '',
  });

  const [klinikler, setKlinikler] = useState([]);
  const [paketler, setPaketler] = useState([]);
  const [seciliPaketIds, setSeciliPaketIds] = useState(new Set());

  useEffect(() => {
    // Gerekli verileri (paketler ve klinikler) API'den çek
    api.get('/admin/paketler').then(res => setPaketler(res.data || []));
    api.get('/admin/klinikler').then(res => setKlinikler(res.data || []));
  }, []);

  useEffect(() => {
    // Eğer düzenleme modu ise, formu mevcut diyetisyen bilgileriyle doldur
    if (mevcutDiyetisyen) {
      // 2. Formu doldururken 'klinik_id'nin doğru şekilde ayarlandığından emin olalım
      setFormData({
        kullanici_adi: mevcutDiyetisyen.kullanici_adi || '',
        eposta: mevcutDiyetisyen.eposta || '',
        telefon: mevcutDiyetisyen.telefon || '',
        sifre: '',
        abonelik_bitis_tarihi: mevcutDiyetisyen.abonelik_bitis_tarihi ? mevcutDiyetisyen.abonelik_bitis_tarihi.split('T')[0] : '',
        klinik_id: mevcutDiyetisyen.klinik_id || '',
      });
      setSeciliPaketIds(new Set(mevcutDiyetisyen.paketler.map(p => p.id)));
    } else {
      // Yeni ekleme modu ise formu sıfırla
      setFormData({ kullanici_adi: '', eposta: '', telefon: '', sifre: '', abonelik_bitis_tarihi: '', klinik_id: '' });
      setSeciliPaketIds(new Set());
    }
  }, [mevcutDiyetisyen]);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handlePaketChange = (paketId) => {
    const newSet = new Set(seciliPaketIds);
    if (newSet.has(paketId)) {
      newSet.delete(paketId);
    } else {
      newSet.add(paketId);
    }
    setSeciliPaketIds(newSet);
  };

  // 3. handleSubmit fonksiyonunun en güncel ve doğru hali
  const handleSubmit = (e) => {
    e.preventDefault();
    const isUpdating = !!mevcutDiyetisyen;

    // Gönderilecek veriyi doğrudan state'ten kopyala
    const gonderilecekVeri = { ...formData };
    
    // Gerekli diğer verileri ekle
    gonderilecekVeri.paket_ids = Array.from(seciliPaketIds);
    gonderilecekVeri.rol = 'diyetisyen';

    // Eğer 'klinik_id' alanı boş bir string ise (örn: "Bağımsız" seçiliyse),
    // bu anahtarı backend'e hiç gönderme ki backend bunu NULL olarak işlesin.
    // Eğer doluysa (bir klinik seçiliyse), ona dokunma.
    if (gonderilecekVeri.klinik_id === '' || gonderilecekVeri.klinik_id === null) {
      delete gonderilecekVeri.klinik_id;
    }

    // Düzenleme modundaysak ve şifre alanı boş bırakılmışsa, şifre anahtarını sil
    if (isUpdating && !gonderilecekVeri.sifre) {
      delete gonderilecekVeri.sifre;
    }

    // Nihai veriyi ana bileşene gönder
    onFormSubmit(gonderilecekVeri);
  };

  return (
    <Form onSubmit={handleSubmit}>
      <Form.Group className="mb-3">
        <Form.Label>Kullanıcı Adı</Form.Label>
        <Form.Control type="text" name="kullanici_adi" value={formData.kullanici_adi} onChange={handleChange} required />
      </Form.Group>
      <Form.Group className="mb-3">
        <Form.Label>E-posta</Form.Label>
        <Form.Control type="email" name="eposta" value={formData.eposta} onChange={handleChange} required />
      </Form.Group>
      <Form.Group className="mb-3">
        <Form.Label>Telefon</Form.Label>
        <Form.Control type="tel" name="telefon" value={formData.telefon} onChange={handleChange} />
      </Form.Group>
      <Form.Group className="mb-3">
        <Form.Label>Şifre</Form.Label>
        <Form.Control type="password" name="sifre" value={formData.sifre} onChange={handleChange} placeholder={mevcutDiyetisyen ? 'Değiştirmek için doldurun' : ''} required={!mevcutDiyetisyen} />
      </Form.Group>
      
      <Form.Group className="mb-3">
        <Form.Label>Atanacak Klinik</Form.Label>
        <Form.Select name="klinik_id" value={formData.klinik_id} onChange={handleChange}>
          <option value="">Bağımsız (Yeni Kişisel Klinik Oluşturulur)</option>
          {klinikler.map(klinik => (
            <option key={klinik.id} value={klinik.id}>{klinik.ad}</option>
          ))}
        </Form.Select>
      </Form.Group>

      <Form.Group className="mb-3">
        <Form.Label>Abonelik Bitiş Tarihi</Form.Label>
        <Form.Control type="date" name="abonelik_bitis_tarihi" value={formData.abonelik_bitis_tarihi} onChange={handleChange} />
      </Form.Group>
      <Form.Group className="mb-3">
        <Form.Label>Atanacak Paketler</Form.Label>
        {paketler.map(paket => (
          <Form.Check 
            type="checkbox"
            key={paket.id}
            id={`paket-${paket.id}`}
            label={`${paket.ad} (${paket.fiyat} TL)`}
            checked={seciliPaketIds.has(paket.id)}
            onChange={() => handlePaketChange(paket.id)}
          />
        ))}
      </Form.Group>
      <div className="d-flex justify-content-end">
        <Button variant="secondary" onClick={onIptal} className="me-2">İptal</Button>
        <Button variant="success" type="submit">{mevcutDiyetisyen ? 'DEĞİŞİKLİKLERİ KAYDET' : 'YENİ DİYETİSYEN EKLE'}</Button>
      </div>
    </Form>
  );
}

export default DiyetisyenFormu;